module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Light-18e9f59dc07bd69beefa34c301094ae3.woff";